import React, { useState } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlus, faSave, faSearch, faArrowUp, faArrowDown, faCloudUpload } from '@fortawesome/free-solid-svg-icons';
// import { Tooltip } from 'react-tooltip';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '../../Shared/Searchbar.css';
// import * as XLSX from 'xlsx';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { useNavigate } from 'react-router-dom';
import ManVis from './ManVis';

import AutoGenQuote from '../../Quote/AutoGenQ';


const Manhole = () => {
  const [baseParameters, setBaseParameters] = useState({
    diameterWidth: '',
    thickness: '',
    material: '',
    invertLevel: '',
    benchingSlope: ''
  });

  const [riserParameters, setRiserParameters] = useState({
    diameter: '',
    height: '',
    thickness: '',
    material: '',
    jointingMethod: ''
  });

  const handleBaseChange = (event) => {
    const { name, value } = event.target;
    setBaseParameters(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleRiserChange = (event) => {
    const { name, value } = event.target;
    setRiserParameters(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  return (
    <>
  <AutoGenQuote></AutoGenQuote>
  <ManVis></ManVis>

  </>

  )}

export default Manhole;

